var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Call") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    stroke: "#000",
    d: "M6.348 4.883c0.094-0.094 0.141-0.141 0.183-0.179 1.020-0.937 2.588-0.937 3.609 0 0.041 0.038 0.089 0.085 0.183 0.179l1.944 1.944c1.069 1.069 1.375 2.684 0.771 4.071s-0.298 3.001 0.771 4.071l3.196 3.196c1.069 1.069 2.684 1.375 4.071 0.771s3.001-0.298 4.071 0.771l1.944 1.944c0.094 0.094 0.141 0.141 0.179 0.183 0.937 1.020 0.937 2.588 0 3.609-0.038 0.042-0.085 0.089-0.179 0.183l-1.182 1.182c-0.962 0.962-2.35 1.366-3.678 1.071-9.053-2.012-16.123-9.082-18.135-18.135-0.295-1.329 0.109-2.716 1.071-3.678l1.182-1.182z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall2);
export default __webpack_public_path__ + "static/media/Call2.5d7026106eec3688e05fc9679289af0b.svg";
export { ForwardRef as ReactComponent };